import { LOGGER_SHOW_LOGS_LOCAL_STORE_KEY } from 'components/Logger/Logger.values';
import pjson from '../../package.json';
import { IAPI_URL, IAPP_INFO, ICHAT_API_URL, ICLEVERTAP_CONFIG, ILINK_INSTALL_APPS } from './@types';

const ENV = process.env.REACT_APP_ENVIRONMENT || 'development';

const IS_PROD = ENV === 'production';

const PAYWALL_DOMAIN = (process.env.REACT_APP_PAYWALL_DOMAIN || '').toLowerCase();
const PP_DOMAIN = (process.env.REACT_APP_PP_DOMAIN || '').toLowerCase();

const SHOW_LOGS = window.localStorage.getItem(LOGGER_SHOW_LOGS_LOCAL_STORE_KEY) === 'true';

const APP_INFO: IAPP_INFO = {
  isProd: IS_PROD,
  showLogs: SHOW_LOGS,
  Env: ENV,
  name: pjson.name,
  version: pjson.version,
  description: 'kinedu onboarding',
  versionComplete: `v${pjson.version}`,
  buildName: 'CT & SW BUILD',
  buildDescription: 'CLEVERTAP & SUPERWALL BUILD',
  isPaywallDomain: window.location.host.toLowerCase().search(PAYWALL_DOMAIN) !== -1,
  isPPDomain: window.location.host.toLowerCase().search(PP_DOMAIN) !== -1,
  date: '12-11-2025',
};

const API_URL: IAPI_URL = {
  base: process.env.REACT_APP_API_BASE || '',
  name: process.env.REACT_APP_API_NAME || '',
  timeout: Number(String(process.env.REACT_APP_API_BASE_TIMEOUT)) || 60000,
  versions: {
    V3: 'v3',
    V4: 'v4',
    V5: 'v5',
  },
};

const CHAT_API_URL: ICHAT_API_URL = {
  base: process.env.REACT_APP_CHAT_API_BASE || '',
  name: process.env.REACT_APP_CHAT_API_NAME || '',
  timeout: Number(String(process.env.REACT_APP_CHAT_API_BASE_TIMEOUT)) || 60000,
  versions: {
    V1: 'v1',
    V2: 'v2',
  },
  token: process.env.REACT_APP_CHAT_API_TOKEN || '',
};

const EVENTS_CONFIG = {
  META_PIXEL: {
    PIXEL_ID: process.env.REACT_APP_META_PIXEL_ID || '',
  },
  MIXPANEL: {
    KEY: process.env.REACT_APP_MIXPANEL_API_KEY || '',
  },
};

const CLEVERTAP_CONFIG: ICLEVERTAP_CONFIG = {
  PROJECT_ID: `${process.env.REACT_APP_CLEVERTAP_PROJECT_ID}`,
  REGION: `${process.env.REACT_APP_CLEVERTAP_REGION}`,
  TOKEN: `${process.env.REACT_APP_CLEVERTAP_TOKEN}`,
}

const LINK_INSTALL_APPS: ILINK_INSTALL_APPS = {
  APPSTORE: {
    ID: process.env.REACT_APP_APPSTORE_ID || '',
    BROWSER: `https://apps.apple.com/us/app/kinedu-baby-development-plan/${process.env.REACT_APP_APPSTORE_ID}`,
    MOBILE: `https://apps.apple.com/us/app/kinedu-baby-development-app/${process.env.REACT_APP_APPSTORE_ID}`,
  },
  PLAYSTORE: {
    ID: process.env.REACT_APP_PLAYSTORE_ID || '',
    BROWSER: `https://play.google.com/store/apps/details?id=${process.env.REACT_APP_PLAYSTORE_ID}&hl=es_419`,
    MOBILE: `market://details?id=${process.env.REACT_APP_PLAYSTORE_ID}`,
  },
};

const STRIPE = {
  PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY || '',
  PUBLIC_KEY_BRAZIL: process.env.REACT_APP_STRIPE_BRAZIL_PUBLIC_KEY || '',
};

const PAYPAL = {
  CLIENT_ID: process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
};

const SENTRY_DNS: string = process.env.REACT_APP_SENTRY_DNS || '';

const FORMSTACK_QUIZ = {
  FORMS_URLS: {
    en: process.env.REACT_APP_FORMSTACK_QUIZ_URL_EN || '',
    es: process.env.REACT_APP_FORMSTACK_QUIZ_URL_ES || '',
    pt: process.env.REACT_APP_FORMSTACK_QUIZ_URL_PT || '',
  },
};

const EXTERNAL_ROUTES = {
  KWA: process.env.REACT_APP_KWA_URL || '',
};

window.Kinedu = {
  ...APP_INFO,
};

export {
  APP_INFO,
  API_URL,
  CHAT_API_URL,
  ENV,
  IS_PROD,
  EVENTS_CONFIG,
  SHOW_LOGS,
  CLEVERTAP_CONFIG,
  LINK_INSTALL_APPS,
  STRIPE,
  SENTRY_DNS,
  PAYPAL,
  FORMSTACK_QUIZ,
  EXTERNAL_ROUTES,
};
